export default __webpack_public_path__ + "static/media/lonking.8d183429.gif";